import React from 'react';
import { Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(({ colors }: Theme) => createStyles({
  root: {
    color: colors.navigation,
    fontWeight: 500,
    fontFamily: 'Montserrat',
    textAlign: 'center',
  },
}), { name: 'PagesTitle' });

type Props = {
  children: React.ReactNode;
  className?: string;
};

const PagesTitle = ({ children, className }: Props) => {
  const classes = useStyles();

  return (
    <Typography
      className={clsx(className, classes.root)}
      component="h1"
      variant="h5"
    >
      {children}
    </Typography>
  );
};

export default PagesTitle;
